import React from 'react';

export default class FullScreenSpinner extends React.Component {
  render = () => (
    <div className={'full_screen_fixed__modal full_screen_fixed__wrapper'}>
      <i className="fa fa-cog fa-spin" style={{ fontSize: '10vh' }} />
    </div>
  );
}
